export function getDataJWT() {
	if (window.localStorage.getItem('_token_')) {
		var base64Url = window.localStorage.getItem('_token_').split('.')[1];
		var base64 = base64Url.replace('-', '+').replace('_', '/');
		return JSON.parse(window.atob(base64));
	} else {
		return false;
	}
}
export function getislogued() {
	if (window.localStorage.getItem('islogued')) {
		return window.localStorage.getItem('islogued');
	} else {
		return false;
	}
}

export function getFavorities() {
	if (window.localStorage.getItem('favorities')) {
		return JSON.parse(window.localStorage.getItem('favorities'));
	} else {
		return false;
	}
}

export function getPathImg() {
	if (window.localStorage.getItem('path_img')) {
		return window.localStorage.getItem('path_img');
	} else {
		return "default";
	}
}

export function getidmoneda() {
	if (window.localStorage.getItem('idmoneda')) {
		return window.localStorage.getItem('idmoneda');
	} else {
		return 1;
	}
}
export function getcompany() {
	if (window.localStorage.getItem('company')) {
		return window.localStorage.getItem('company');
	} else {
		return "Inicio";
	}
}
export function getorders() {
	if (window.localStorage.getItem('orders')) {
		return JSON.parse(window.localStorage.getItem('orders'));
	} else {
		return false;
	}
}

export function getchek() {
	if (window.localStorage.getItem('ari_chek')) {
		return window.localStorage.getItem('ari_chek');
	} else {
		return false;
	}
}
export function getpermissions() {
	if (window.localStorage.getItem('permissions')) {
		return JSON.parse(window.localStorage.getItem('permissions'));
	} else {
		return false;
	}
}
export function getPreEmail() {
	if (window.localStorage.getItem('prev_email')) {
		return window.localStorage.getItem('prev_email');
	} else {
		return "default";
	}
}
export function getfilterCategorie() {
	if (window.localStorage.getItem('filterCategorie')) {
		return JSON.parse(window.localStorage.getItem('filterCategorie'));
	} else {
		return false;
	}
}


export function getshoppingcart_client() {
	if (window.localStorage.getItem('shoppingcart_client')) {
		return JSON.parse(window.localStorage.getItem('shoppingcart_client'));
	} else {
		return { name: "", phone: "", address: "", note: "" };
	}
}
export function getsearch_input() {
	if (window.localStorage.getItem('search_input')) {
		return window.localStorage.getItem('search_input');
	} else {
		return "";
	}
}
export function getImageDefault() {
	if (window.localStorage.getItem('img_default')) {
		return window.localStorage.getItem('img_default');
	} else {
		return "";
	}
}
export function getOrderNumber() {
	if (window.localStorage.getItem('edit_order_number')) {
		return window.localStorage.getItem('edit_order_number');
	} else {
		return "";
	}
}
//////////////////////////////////////////////////////////////////////
export function getTransactionPayments() {
	if (window.localStorage.getItem('ari_app_transaction_payments')) {
		return JSON.parse(window.localStorage.getItem('ari_app_transaction_payments'));
	} else {
		return false;
	}
}

export function getShoppingCart() {
	if (window.localStorage.getItem('ari_app_shoppingcart')) {
		return JSON.parse(window.localStorage.getItem('ari_app_shoppingcart'));
	} else {
		return false;
	}
}

export function getLoginApp() {
	if (window.localStorage.getItem('data_login_ari_app')) {
		return JSON.parse(window.localStorage.getItem('data_login_ari_app'));
	} else {
		return false;
	}
}
export function getPermissions() {
	if (window.localStorage.getItem('ari_app_permissions')) {
		return JSON.parse(window.localStorage.getItem('ari_app_permissions'));
	} else {
		return [];
	}
}
export function getEnabledModules() {
	if (window.localStorage.getItem('ari_app_enabled_modules')) {
		return JSON.parse(window.localStorage.getItem('ari_app_enabled_modules'));
	} else {
		return [];
	}
}
export function getLATLNG() {
	if (window.localStorage.getItem('ari_app_lat_long')) {
		return JSON.parse(window.localStorage.getItem('ari_app_lat_long'));
	} else {
		return false;
	}
}
export function getTransactions() {
	if (window.localStorage.getItem('ari_app_transaction')) {
		return JSON.parse(window.localStorage.getItem('ari_app_transaction'));
	} else {
		return false;
	}
}

export function getModeList() {
	if (window.localStorage.getItem('ari_app_mode_list')) {
		return window.localStorage.getItem('ari_app_mode_list') == "true";
	} else {
		return false;
	}
}

export function getContact() {
	if (window.localStorage.getItem('ari_app_contact')) {
		return JSON.parse(window.localStorage.getItem('ari_app_contact'));
	} else {
		return false;
	}
}

export function getCashRegister() {
	if (window.localStorage.getItem('current_register')) {
		return JSON.parse(window.localStorage.getItem('current_register'));
	} else {
		return false;
	}
}

export function getDominio() {

	if (window.localStorage.getItem('ari_app_dominio')) {
		return window.localStorage.getItem('ari_app_dominio');
	} else {
		return "";
	}
}


export function getNewLogin() {

	if (window.localStorage.getItem('ari_app_new_login')) {
		return window.localStorage.getItem('ari_app_new_login');
	} else {
		return 0;
	}
}

export function getTransactionTaxDisc() {
	if (window.localStorage.getItem('data_transactiotaxdic')) {
		return JSON.parse(window.localStorage.getItem('data_transactiotaxdic'));
	} else {
		return false;
	}
}
export function getToken() {
	if (window.localStorage.getItem('ari_app_token')) {
		return window.localStorage.getItem('ari_app_token');
	} else {
		return false;
	}
}

export function getDepartamentos() {
	return [
		{ id: "", name: "Seleccione" },
		{ id: "Boaco", name: "Boaco" },
		{ id: "Carazo", name: "Carazo" },
		{ id: "Chinandega", name: "Chinandega" },
		{ id: "Chontales", name: "Chontales" },
		{ id: "RACCN", name: "RACCN" },
		{ id: "RACCS", name: "RACCS" },
		{ id: "Estelí", name: "Estelí" },
		{ id: "Granada", name: "Granada" }, { id: "Jinotega", name: "Jinotega" },
		{ id: "León", name: "León" },
		{ id: "Madriz", name: "Madriz" },
		{ id: "Managua", name: "Managua" },
		{ id: "Masaya", name: "Masaya" },
		{ id: "Matagalpa", name: "Matagalpa" },
		{ id: "Nueva Segovia", name: "Nueva Segovia" },
		{ id: "Río San Juan", name: "Río San Juan" },
		{ id: "Rivas", name: "Rivas" }
	]
}

export function getMunicipios() {
	return [
		{
			id: 'Achuapa',
			name: 'Achuapa',
			padre: 'León'
		},
		{
			id: 'Acoyapa',
			name: 'Acoyapa',
			padre: 'Chontales'
		},
		{
			id: 'Altagracia',
			name: 'Altagracia',
			padre: 'Rivas'
		},
		{
			id: 'Belén',
			name: 'Belén',
			padre: 'Rivas'
		},
		{
			id: 'Bilwi',
			name: 'Bilwi',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Bluefields',
			name: 'Bluefields',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Boaco',
			name: 'Boaco',
			padre: 'Boaco'
		},
		{
			id: 'Boca de Sábalos',
			name: 'Boca de Sábalos',
			padre: 'Río San Juan'
		},
		{
			id: 'Bocana de Paiwas',
			name: 'Bocana de Paiwas',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Bonanza',
			name: 'Bonanza',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Buenos Aires',
			name: 'Buenos Aires',
			padre: 'Rivas'
		},
		{
			id: 'Camoapa',
			name: 'Camoapa',
			padre: 'Boaco'
		},
		{
			id: 'Cárdenas',
			name: 'Cárdenas',
			padre: 'Rivas'
		},
		{
			id: 'Catarina',
			name: 'Catarina',
			padre: 'Masaya'
		},
		{
			id: 'Chichigalpa',
			name: 'Chichigalpa',
			padre: 'Chinandega'
		},
		{
			id: 'Chinandega',
			name: 'Chinandega',
			padre: 'Chinandega'
		},
		{
			id: 'Cinco Pinos',
			name: 'Cinco Pinos',
			padre: 'Chinandega'
		},
		{
			id: 'Ciudad Antigua',
			name: 'Ciudad Antigua',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Ciudad Darío',
			name: 'Ciudad Darío',
			padre: 'Matagalpa'
		},
		{
			id: 'Ciudad Sandino',
			name: 'Ciudad Sandino',
			padre: 'Managua'
		},
		{
			id: 'Comalapa',
			name: 'Comalapa',
			padre: 'Chontales'
		},
		{
			id: 'Condega',
			name: 'Condega',
			padre: 'Estelí'
		},
		{
			id: 'Corinto',
			name: 'Corinto',
			padre: 'Chinandega'
		},
		{
			id: 'Corn Island',
			name: 'Corn Island',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Cuapa',
			name: 'Cuapa',
			padre: 'Chontales'
		},
		{
			id: 'Dipilto',
			name: 'Dipilto',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Diriá',
			name: 'Diriá',
			padre: 'Granada'
		},
		{
			id: 'Diriamba',
			name: 'Diriamba',
			padre: 'Carazo'
		},
		{
			id: 'Diriomo',
			name: 'Diriomo',
			padre: 'Granada'
		},
		{
			id: 'Dolores',
			name: 'Dolores',
			padre: 'Carazo'
		},
		{
			id: 'El Almendro',
			name: 'El Almendro',
			padre: 'Río San Juan'
		},
		{
			id: 'El Ayote',
			name: 'El Ayote',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'El Coral',
			name: 'El Coral',
			padre: 'Chontales'
		},
		{
			id: 'El Crucero',
			name: 'El Crucero',
			padre: 'Managua'
		},
		{
			id: 'El Cuá',
			name: 'El Cuá',
			padre: 'Jinotega'
		},
		{
			id: 'El Jicaral',
			name: 'El Jicaral',
			padre: 'León'
		},
		{
			id: 'El Jícaro',
			name: 'El Jícaro',
			padre: 'Nueva Segovia'
		},
		{
			id: 'El Rama',
			name: 'El Rama',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'El Realejo',
			name: 'El Realejo',
			padre: 'Chinandega'
		},
		{
			id: 'El Rosario',
			name: 'El Rosario',
			padre: 'Carazo'
		},
		{
			id: 'El Sauce',
			name: 'El Sauce',
			padre: 'León'
		},
		{
			id: 'El Tortuguero',
			name: 'El Tortuguero',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'El Viejo',
			name: 'El Viejo',
			padre: 'Chinandega'
		},
		{
			id: 'Esquipulas',
			name: 'Esquipulas',
			padre: 'Matagalpa'
		},
		{
			id: 'Estelí',
			name: 'Estelí',
			padre: 'Estelí'
		},
		{
			id: 'Granada',
			name: 'Granada',
			padre: 'Granada'
		},
		{
			id: 'Greytown',
			name: 'Greytown',
			padre: 'Río San Juan'
		},
		{
			id: 'Jalapa',
			name: 'Jalapa',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Jinotega',
			name: 'Jinotega',
			padre: 'Jinotega'
		},
		{
			id: 'Jinotepe',
			name: 'Jinotepe',
			padre: 'Carazo'
		},
		{
			id: 'Juigalpa',
			name: 'Juigalpa',
			padre: 'Chontales'
		},
		{
			id: 'Karawala',
			name: 'Karawala',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Kukrahill',
			name: 'Kukrahill',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'La Concepción',
			name: 'La Concepción',
			padre: 'Masaya'
		},
		{
			id: 'La Concordia',
			name: 'La Concordia',
			padre: 'Jinotega'
		},
		{
			id: 'La Conquista',
			name: 'La Conquista',
			padre: 'Carazo'
		},
		{
			id: 'La Cruz de Río Grande',
			name: 'La Cruz de Río Grande',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'La Dalia',
			name: 'La Dalia',
			padre: 'Matagalpa'
		},
		{
			id: 'La Libertad',
			name: 'La Libertad',
			padre: 'Chontales'
		},
		{
			id: 'La Paz Centro',
			name: 'La Paz Centro',
			padre: 'León'
		},
		{
			id: 'La Paz de Carazo',
			name: 'La Paz de Carazo',
			padre: 'Carazo'
		},
		{
			id: 'La Trinidad',
			name: 'La Trinidad',
			padre: 'Estelí'
		},
		{
			id: 'Laguna de Perlas',
			name: 'Laguna de Perlas',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Larreynaga',
			name: 'Larreynaga',
			padre: 'León'
		},
		{
			id: 'Las Sabanas',
			name: 'Las Sabanas',
			padre: 'Madriz'
		},
		{
			id: 'León',
			name: 'León',
			padre: 'León'
		},
		{
			id: 'Macuelizo',
			name: 'Macuelizo',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Malpaisillo',
			name: 'Malpaisillo',
			padre: 'León'
		},
		{
			id: 'Managua',
			name: 'Managua',
			padre: 'Managua'
		},
		{
			id: 'Masatepe',
			name: 'Masatepe',
			padre: 'Masaya'
		},
		{
			id: 'Masaya',
			name: 'Masaya',
			padre: 'Masaya'
		},
		{
			id: 'Matagalpa',
			name: 'Matagalpa',
			padre: 'Matagalpa'
		},
		{
			id: 'Mateare',
			name: 'Mateare',
			padre: 'Managua'
		},
		{
			id: 'Matiguás',
			name: 'Matiguás',
			padre: 'Matagalpa'
		},
		{
			id: 'Morrito',
			name: 'Morrito',
			padre: 'Río San Juan'
		},
		{
			id: 'Moyogalpa',
			name: 'Moyogalpa',
			padre: 'Rivas'
		},
		{
			id: 'Mozonte',
			name: 'Mozonte',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Muelle de los Bueyes',
			name: 'Muelle de los Bueyes',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Mulukukú',
			name: 'Mulukukú',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Murra',
			name: 'Murra',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Muy Muy',
			name: 'Muy Muy',
			padre: 'Matagalpa'
		},
		{
			id: 'Nagarote',
			name: 'Nagarote',
			padre: 'León'
		},
		{
			id: 'Nandaime',
			name: 'Nandaime',
			padre: 'Granada'
		},
		{
			id: 'Nandasmo',
			name: 'Nandasmo',
			padre: 'Masaya'
		},
		{
			id: 'Nindirí',
			name: 'Nindirí',
			padre: 'Masaya'
		},
		{
			id: 'Niquinohomo',
			name: 'Niquinohomo',
			padre: 'Masaya'
		},
		{
			id: 'Nueva Guinea',
			name: 'Nueva Guinea',
			padre: 'Costa Caribe Sur'
		},
		{
			id: 'Ocotal',
			name: 'Ocotal',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Palacagüina',
			name: 'Palacagüina',
			padre: 'Madriz'
		},
		{
			id: 'Pantasma',
			name: 'Pantasma',
			padre: 'Jinotega'
		},
		{
			id: 'Posoltega',
			name: 'Posoltega',
			padre: 'Chinandega'
		},
		{
			id: 'Potosí',
			name: 'Potosí',
			padre: 'Rivas'
		},
		{
			id: 'Prinzapolka',
			name: 'Prinzapolka',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Pueblo Nuevo',
			name: 'Pueblo Nuevo',
			padre: 'Estelí'
		},
		{
			id: 'Quezalguaque',
			name: 'Quezalguaque',
			padre: 'León'
		},
		{
			id: 'Quilalí',
			name: 'Quilalí',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Rancho Grande',
			name: 'Rancho Grande',
			padre: 'Matagalpa'
		},
		{
			id: 'Río Blanco',
			name: 'Río Blanco',
			padre: 'Matagalpa'
		},
		{
			id: 'Rivas',
			name: 'Rivas',
			padre: 'Rivas'
		},
		{
			id: 'Rosita',
			name: 'Rosita',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'San Carlos',
			name: 'San Carlos',
			padre: 'Río San Juan'
		},
		{
			id: 'San Dionisio',
			name: 'San Dionisio',
			padre: 'Matagalpa'
		},
		{
			id: 'San Fernando',
			name: 'San Fernando',
			padre: 'Nueva Segovia'
		},
		{
			id: 'San Francisco del Norte',
			name: 'San Francisco del Norte',
			padre: 'Chinandega'
		},
		{
			id: 'San Francisco Libre',
			name: 'San Francisco Libre',
			padre: 'Managua'
		},
		{
			id: 'San Isidro',
			name: 'San Isidro',
			padre: 'Matagalpa'
		},
		{
			id: 'San Jorge',
			name: 'San Jorge',
			padre: 'Rivas'
		},
		{
			id: 'San José de Bocay',
			name: 'San José de Bocay',
			padre: 'Jinotega'
		},
		{
			id: 'San José de Cusmapa',
			name: 'San José de Cusmapa',
			padre: 'Madriz'
		},
		{
			id: 'San José de los Remates',
			name: 'San José de los Remates',
			padre: 'Boaco'
		},
		{
			id: 'San Juan de Limay',
			name: 'San Juan de Limay',
			padre: 'Estelí'
		},
		{
			id: 'San Juan de Oriente',
			name: 'San Juan de Oriente',
			padre: 'Masaya'
		},
		{
			id: 'San Juan de Río Coco',
			name: 'San Juan de Río Coco',
			padre: 'Madriz'
		},
		{
			id: 'San Juan del Sur',
			name: 'San Juan del Sur',
			padre: 'Rivas'
		},
		{
			id: 'San Lorenzo',
			name: 'San Lorenzo',
			padre: 'Boaco'
		},
		{
			id: 'San Lucas',
			name: 'San Lucas',
			padre: 'Madriz'
		},
		{
			id: 'San Marcos',
			name: 'San Marcos',
			padre: 'Carazo'
		},
		{
			id: 'San Miguelito',
			name: 'San Miguelito',
			padre: 'Río San Juan'
		},
		{
			id: 'San Nicolás',
			name: 'San Nicolás',
			padre: 'Estelí'
		},
		{
			id: 'San Pedro de Lóvago',
			name: 'San Pedro de Lóvago',
			padre: 'Chontales'
		},
		{
			id: 'San Pedro del Norte',
			name: 'San Pedro del Norte',
			padre: 'Chinandega'
		},
		{
			id: 'San Rafael del Norte',
			name: 'San Rafael del Norte',
			padre: 'Jinotega'
		},
		{
			id: 'San Rafael del Sur',
			name: 'San Rafael del Sur',
			padre: 'Managua'
		},
		{
			id: 'San Ramón',
			name: 'San Ramón',
			padre: 'Matagalpa'
		},
		{
			id: 'San Sebastián de Yalí',
			name: 'San Sebastián de Yalí',
			padre: 'Jinotega'
		},
		{
			id: 'Santa Lucía',
			name: 'Santa Lucía',
			padre: 'Boaco'
		},
		{
			id: 'Santa María',
			name: 'Santa María',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Santa Rosa del Peñón',
			name: 'Santa Rosa del Peñón',
			padre: 'León'
		},
		{
			id: 'Santo Domingo',
			name: 'Santo Domingo',
			padre: 'Chontales'
		},
		{
			id: 'Santo Tomás',
			name: 'Santo Tomás',
			padre: 'Chontales'
		},
		{
			id: 'Santo Tomás del Norte',
			name: 'Santo Tomás del Norte',
			padre: 'Chinandega'
		},
		{
			id: 'Sébaco',
			name: 'Sébaco',
			padre: 'Matagalpa'
		},
		{
			id: 'Siuna',
			name: 'Siuna',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Somotillo',
			name: 'Somotillo',
			padre: 'Chinandega'
		},
		{
			id: 'Somoto',
			name: 'Somoto',
			padre: 'Madriz'
		},
		{
			id: 'Telica',
			name: 'Telica',
			padre: 'León'
		},
		{
			id: 'Telpaneca',
			name: 'Telpaneca',
			padre: 'Madriz'
		},
		{
			id: 'Terrabona',
			name: 'Terrabona',
			padre: 'Matagalpa'
		},
		{
			id: 'Teustepe',
			name: 'Teustepe',
			padre: 'Boaco'
		},
		{
			id: 'Ticuantepe',
			name: 'Ticuantepe',
			padre: 'Managua'
		},
		{
			id: 'Tipitapa',
			name: 'Tipitapa',
			padre: 'Managua'
		},
		{
			id: 'Tisma',
			name: 'Tisma',
			padre: 'Masaya'
		},
		{
			id: 'Tola',
			name: 'Tola',
			padre: 'Rivas'
		},
		{
			id: 'Tonalá',
			name: 'Tonalá',
			padre: 'Chinandega'
		},
		{
			id: 'Totogalpa',
			name: 'Totogalpa',
			padre: 'Madriz'
		},
		{
			id: 'Villa El Carmen',
			name: 'Villa El Carmen',
			padre: 'Managua'
		},
		{
			id: 'Villa Sandino',
			name: 'Villa Sandino',
			padre: 'Chontales'
		},
		{
			id: 'Villanueva',
			name: 'Villanueva',
			padre: 'Chinandega'
		},
		{
			id: 'Waslala',
			name: 'Waslala',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Waspán',
			name: 'Waspán',
			padre: 'Costa Caribe Norte'
		},
		{
			id: 'Wiwilí',
			name: 'Wiwilí',
			padre: 'Nueva Segovia'
		},
		{
			id: 'Wiwilí de Jinotega',
			name: 'Wiwilí de Jinotega',
			padre: 'Jinotega'
		},
		{
			id: 'Yalagüina',
			name: 'Yalagüina',
			padre: 'Madriz'
		},
	];

}


